import React,{ useState, useEffect, useRef, Fragment } from "react";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
import "../../../css/bootstrap.min.css";
import "../../../css/font.css";
import { Link, useNavigate,useParams } from 'react-router-dom'
import axios from "axios";
import { association, officials } from '../../../apis/urls'
import { $ } from "react-jquery-plugin";
import { Dropdown } from "rsuite";



const EditOfficials = () => {

    let navigate = useNavigate();

    const statesData = ["AL","AK","AS","AR","AZ","CA","CO","CT","DE","DC","FM","FL","GA","GU","HI","ID","IL","IN","IA","KS","KY","LA","ME","MH","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PW","PA","PR","RI","SC","SD","TN","TX","UT","VT","VI","VA","WA","WV","WI","WY"];


    const [result, setResult] = useState([]);
    const [fname, setFname] = useState('');
    const [lname, setLname] = useState('');
    const [adrs1, setAdrs1] = useState('');
    const [adrs2, setAdrs2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState(null);
    const [email, setEmail] = useState('');
    const [workph, setWorkPh] = useState('');
    const [homeph, setHomePh] = useState('');
    const [status, setStatus] = useState('');

    const [fnameerr, setFnameerr] = useState('');
    const [lnameerr, setLnameerr] = useState('');
    const [adrs1err, setAdrs1err] = useState('');
    const [adrs2err, setAdrs2err] = useState('');
    const [cityerr, setCityerr] = useState('');
    const [stateerr, setStateerr] = useState('');
    const [ziperr, setZiperr] = useState('');
    const [emailerr, setEmailerr] = useState('');
    const [workpherr, setWorkPherr] = useState('');
    const [homepherr, setHomePherr] = useState('');
    const [statuserr, setStatuserr] = useState('');
    const [assoid, setAssoid] = useState('');

    const firstRender = useRef(true);
    const [disable, setDisabled] = useState(true);
    const [error, setErrors] = useState(null);
    const [phoneerror, setPhoneErrors] = useState(null);
    const [emailExist, setEmailExist] = useState('');


    const [city2Error,setCity2Error] = useState(false);
    const [add2Error,setAdd2Error] = useState(false);
    const [state2Error,setState2Error] = useState(false);


    let arr = localStorage.getItem('association');

    let associationIds = arr.split(',');

    

    useEffect(() => {
        if (firstRender.current) {
          firstRender.current = false;
          return;
        }
    
    const formValidation = () => {
        const emailValidation = !/\S+@\S+\.\S+/.test(email);
          if (emailValidation) {
            setErrors("Email address is invalid");
          } else {
            setErrors(null);
          }
        };
       setDisabled(formValidation());

       

    //    const formPhoneValidation = () => {
    //       const phoneValidation = /^\d+$/.test(wphone);
    //       if (phoneValidation) {
    //         setPhoneErrors("Phone number is invalid");
    //       } else {
    //         setPhoneErrors(null);
    //       }
    //     };
    //     setDisabled(formPhoneValidation());



      }, [email,]);

    const {id} = useParams();
    const {assid} = useParams(); 

    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        Listing();
    },[])

    const gotoList = () =>{

        let userrole = localStorage.getItem('userrole');

        if(userrole === 'SUPERADMIN'){
            navigate('/officials/'+assoid)
        }else{
            navigate("/association_officials/"+assoid)
        }
        
    }

    const Listing = () => {
        
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)
    
        const instance = axios.create({
            baseURL: officials+'/association/'+assid+'/'+id,
            timeout: 1000000,
            headers: {'authorization': token}
          });
    
          instance.get('').then(res => {
            setResult(res.data.data);
            setFname(res.data.data.firstname);
            setLname(res.data.data.lastname);
            setAdrs1(res.data.data.address_1);
            setAdrs2(res.data.data.address_2);
            setCity(res.data.data.city);
            setState(res.data.data.state);
            setZip(res.data.data.zip);
            setEmail(res.data.data.email);
            setWorkPh(res.data.data.work_phone);
            setHomePh(res.data.data.home_phone);
            setStatus(res.data.data.status);
            setAssoid(res.data.data.association.id);
        });
    }

    const onEditForm = () => {


        let error = 0;
        if(fname === '')
        {
            setFnameerr(true)
            error =1;
        } 
        if(lname === '')
        {
            setLnameerr(true)
            error =1;
        }  
        // if(adrs1 === '')
        // {
        //     setAdrs1err(true)
        //     error =1;
        // }  
        // if(adrs2 === '')
        // {
        //     setAdrs2err(true)
        //     error =1;
        // }  

        if(city === '')
        {
            setCityerr(true)
            error =1;
        } 
        if(state === '')
        {
            setStateerr(true)
            error =1;
        } 
        // if(zip === '')
        // {
        //     setZiperr(true)
        //     error =1;
        // } 
        if(email === '')
        {
            setEmailerr(true)
            error =1;
        } 
        if(workph === '')
        {
            setWorkPherr(true)
            error =1;
        } 
        if(homeph === '')
        {
            setHomePherr(true)
            error =1;
        } 
        if(city.length < 2){
            setCity2Error(true)
        }else{
            setCity2Error(false)
        }
        // if(adrs1.length < 2){
        //     setAdd2Error(true)
        // }else{
        //     setAdd2Error(false)
        // }
        if(state.length < 2){
            setState2Error(true)
        }else{
            setState2Error(false)
        }
        
        
        //if(error === 0) 
        //{
            let token = "Bearer "+localStorage.getItem('token');     
            const data = {
                firstname: fname,
                lastname: lname,
                address_1: adrs1,
                address_2:adrs2,
                city:city,
                state:state,
                zip: zip,
                email:email,
                work_phone:workph,
                // home_phone:homeph,
                status:status
            }           

            const instance = axios.create({
                baseURL: officials+"/association/"+assid+'/'+id,
                timeout: 1000000,
                headers: {'authorization': token}
            });
            instance.put('',data).then((response) =>{      
                // navigate("/officials/"+assid)
                setResult(response.data.data);
                console.log("Result ==>", response);


                let userrole = localStorage.getItem('userrole');


                if(userrole === 'SUPERADMIN'){
                    navigate('/officials/'+assoid)
                }else{
                    navigate("/association_officials/"+assoid)
                }
                

            }).catch((error) =>{
                console.log('error',error.message)
                setEmailExist(error.response.data.error[0].email)

            });
        //}        
    }

    const role = localStorage.getItem('userrole');

    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Update Officials</h2>
                        </div>
                        
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            {
                              role === 'ASSOCIATION_USER' ? (
                                associationIds.length === 1?null:
                                <li className="breadcrumb-item"><Link to="/select_association">Home</Link></li>
                              ):
                                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            }
                            {
                              role === 'ASSOCIATION_USER' ?null :
                              (
                                <li className="breadcrumb-item"><Link to="/associations"> Association List</Link></li>
                              )
                            }


                            {role === 'ASSOCIATION_USER'?
                                <li className="breadcrumb-item"><Link to={"/association_officials/"+assoid}>Officials List</Link></li>:
                                <li className="breadcrumb-item"><Link to={"/officials/"+assoid}>Officials List</Link></li>
                            }
                            <li className="breadcrumb-item active" aria-current="page">Update Officials</li>
                        </ol>
                    </nav>


                    <form className="needs-validation" noValidate>
                    <div className="form-wrpr">
                            <div className="card formcard medium">
                                <div className="card-body">
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >First Name<span style={{color: "red"}}>*</span></label>
                                            <input type="text" className="form-control justshow bg-dark" defaultValue={result.firstname} onChange={e => {setFname(e.target.value)}} placeholder="Enter First Name" />
                                            {
											fnameerr
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter first name</div>
											:null
                            			}
                                        </div>
                                        <div className="col-md-6">
                                            <label >Last Name<span style={{color: "red"}}>*</span></label>		
                                            <input type="text" className="form-control justshow bg-dark" defaultValue={result.lastname} onChange={e => {setLname(e.target.value)}} placeholder="Enter Last Name" />
                                            {
											lnameerr
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter last name</div>
											:null
                            			    }
                                        </div>
                                    </div>
							    </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Address 1<span style={{color: "red"}}>*</span></label>
                                            <input type="text" className="form-control justshow bg-dark" defaultValue={result.address_1} onChange={e => {setAdrs1(e.target.value)}} placeholder="Enter Address 1" />
                                            {
											adrs1err
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Address 1</div>
											:null
                            			    }
                                            {
                                                add2Error
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Address must be more than 2 charactors.</div>:null
                            			    }
                                        </div>
                                        <div className="col-md-6">
                                            <label >Address 2</label>		
                                            <input type="text" className="form-control justshow bg-dark" defaultValue={result.address_2} onChange={e => {setAdrs2(e.target.value)}} placeholder="Enter Address 2" />
                                            {/* {
											adrs2err
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Address 2</div>
											:null
                            			} */}
                                        </div>
                                    </div>
							    </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >City<span style={{color: "red"}}>*</span></label>
                                            <input type="text" className="form-control justshow bg-dark" defaultValue={result.city} onChange={e => {setCity(e.target.value)}} placeholder="Enter City" />
                                            {
											cityerr
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter City</div>
											:null
                            			}
                                            {
                                                city2Error
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>City must be more than 2 charactors.</div>:null
                            			    }                                    
                                        </div>
                                        <div className="col-md-6">
                                            <label >State <span style={{color: "red"}}>*</span></label>		
                                            <Dropdown title={state?state:"Select State"} className="state-dropdown"
                                             style={{ width:'100%', height:'10px'}}  >
                                                {statesData.map((item, index)=> (

                                                    <Fragment key={index}>
                                                    <Dropdown.Item value={item}
                                                        defaultChecked={state}
                                                        onClick={() => {{setState(item);
                                                            // console.log("aaaa")
                                                            }}}
                                                    
                                                        >{item}</Dropdown.Item>
                                                    </Fragment>
                                                ))}
                                            </Dropdown>
                                            {
											stateerr
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter State</div>
											:null
                            			}
                                            {
                                                state2Error
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>State must be more than 2 charactors.</div>:null
                            			    }
                                        </div>
                                    </div>
							    </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Zip</label>
                                            <input type="number" className="form-control justshow bg-dark" defaultValue={result.zip} onChange={e => {setZip(e.target.value)}} placeholder="Enter Zip" />
                                        </div>
                                        <div className="col-md-6">
                                            <label >Email<span style={{color: "red"}}>*</span></label>		
                                            <input type="email" className="form-control justshow bg-dark" defaultValue={result.email} onChange={e => {setEmail(e.target.value)}} placeholder="Enter Email" />
                                            {
											emailerr
											?<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter email</div>
											:<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{error && <p>{error}</p>}</div>
                            			    }
                                            <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{emailExist? 'Email already in used':null}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Best Contact Phone<span style={{color: "red"}}>*</span></label>
                                            <input type="text" className="form-control justshow bg-dark" defaultValue={result.work_phone} onChange={e => {setWorkPh(e.target.value)}} placeholder="Enter Best Contact Phone" />
                                            {
											workpherr
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Work phone</div>
											:null
                            			}
                                        </div>
                                        {/* <div className="col-md-6">
                                            <label >Home Phone</label>		
                                            <input type="email" className="form-control justshow bg-dark" defaultValue={result.home_phone} onChange={e => {setHomePh(e.target.value)}} placeholder="Enter Home Phone" /> */}
                                            {/* {
											homepherr
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Home phone</div>
											:null
                            			} */}
                                        {/* </div> */}
                                    </div>
                                </div>

                                {/* <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
										<label >Status </label>
										<div className="checkbox-wrpr">
											<select className="form-control bg-dark dark-theme showtext" onChange={e => {setStatus(e.target.value)}} id="status-selector">
												<option value="0">Select Status</option>
												<option value="ACTIVE" selected={result.status === 'ACTIVE'}>ACTIVE</option>
												<option value="INACTIVE" selected={result.units_passed === 'INACTIVE'}>INACTIVE</option>
												<option value="DELETED" selected={result.units_passed === 'DELETED'}>DELETED</option>
											</select>
										</div>
								        </div>
                                    </div>
                                </div> */}
                                

                                {/* <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                        <label >New/Previous</label>
                                        <div class="radio-btn-association">    
                                            <label>
                                                <input type="radio"  name="type" value="New" checked/><span className="new-previous-label">New</span>
                                            </label>
                                            <label>
                                                <input type="radio"  name="type" value="Previous"/><span className="new-previous-label">Previous</span>
                                            </label>
                                         </div>

                                        </div>
                                        
                                    </div>
                                </div> */}

                            

                                
                                <div className="form-group text-right">
							        <button className="btn btn-danger btn-gisa" onClick={gotoList} type="submit">Cancel</button>
								    <button className="btn btn-primary btn-gisa" onClick={onEditForm} type="button">Update </button>
							    </div>

                                </div>
                            </div>
                        </div>
                    </form>





                </div>
            </aside>
        </div>

    )
}

export default EditOfficials;
